<script lang="ts">
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import type { LetterPortalCopy } from "../../../../../../../../../../../../api/kehrblatt/letters"
  let { copy = $bindable(), disabled = false }: { copy: LetterPortalCopy; disabled?: boolean } =
    $props()
  const keys = ["open_portal", "confirm_appointment", "choose_alternative", "complete"] as const
  let editing = $state<(typeof keys)[number] | null>(null)
</script>

<p>Schritte abwählen, um sie im Brief auszublenden. Die Texte bleiben erhalten.</p>
{#each keys as key, index}
  <div class="step" class:inactive={!copy[key].enabled}>
    <div class="step-heading">
      <Input
        type="checkbox"
        placeholder={`Schritt ${index + 1} anzeigen`}
        bind:value={copy[key].enabled}
        brightBackground={true}
        {disabled}
      />
      <button
        type="button"
        class="edit-step"
        aria-expanded={editing === key && copy[key].enabled}
        aria-label={`Schritt ${index + 1}: Text bearbeiten`}
        disabled={disabled || !copy[key].enabled}
        onclick={() => (editing = editing === key ? null : key)}
      >
        {copy[key].title}<span>{editing === key ? "Schließen" : "Bearbeiten"}</span>
      </button>
    </div>
    {#if copy[key].enabled && editing === key}
      <div class="step-fields">
        <Input
          placeholder="Überschrift"
          type="text"
          bind:value={copy[key].title}
          brightBackground={true}
          {disabled}
        />
        <Input
          placeholder="Erklärung"
          type="tagbased_input"
          bind:value={copy[key].body}
          tokenSyntax="single"
          options={[
            { label: "Portaladresse", value: "portal_url" },
            { label: "Termincode", value: "public_code" },
          ]}
          brightBackground={true}
          {disabled}
        />
      </div>
    {/if}
  </div>
{/each}

<style>
  .step {
    border-bottom: 1px solid color-mix(in srgb, var(--text-invers-100) 12%, transparent);
    padding: 0.75rem 0;
    min-width: 0;
  }
  .step-heading {
    display: grid;
    gap: 0.35rem;
  }
  .step-fields {
    display: grid;
    gap: 0.75rem;
    padding: 1rem 0 0;
    min-width: 0;
  }
  .edit-step {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 1rem;
    border: 0;
    background: transparent;
    text-align: left;
    padding: 0.25rem 0;
    font: inherit;
    font-size: 0.9rem;
    color: var(--text-invers-100);
    cursor: pointer;
  }
  .edit-step span {
    font-size: 0.8rem;
    text-decoration: underline;
  }
  .edit-step:disabled {
    cursor: default;
  }
  .edit-step:disabled span {
    visibility: hidden;
  }
  .edit-step:focus-visible {
    outline: 2px solid var(--primary-100);
    outline-offset: 3px;
  }
  .inactive .edit-step {
    opacity: 0.6;
  }
  p {
    color: var(--text-invers-100);
    font-size: 0.85rem;
    line-height: 1.5;
    margin: 0;
  }
</style>
